import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AciPaymentService } from '../../invoices/payments/aci-payment.service';
import { InvoicesService } from '../../services/invoices.service';


export class AppModule { }

@Component({
  selector: 'ngbd-modal-content',
  template: `
    <div class="modal-body text-center ac-success-msg" [style.display]="success?success:'none'">
    <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M31 0C13.95 0 0 13.95 0 31C0 48.05 13.95 62 31 62C48.05 62 62 48.05 62 31C62 13.95 48.05 0 31 0ZM24.8 46.5L9.3 31L13.671 26.629L24.8 37.727L48.329 14.198L52.7 18.6L24.8 46.5Z" fill="#168007"/>
</svg>
    <h4 class="mt-3" style="font-size:24px;">Recurring Scheduled Successfully!</h4>
      <p class="ac-modelpara">{{name}}</p>
            <button type="button" class="close btn ac-btn-outline-primary ac-butncancel" (click)="closed()">Close</button>

    </div>
    <div class="modal-body text-center ac-error-msg" [style.display]="error?error:'none'">
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M36 0C55.908 0 72 16.092 72 36C72 55.908 55.908 72 36 72C16.092 72 0 55.908 0 36C0 16.092 16.092 0 36 0ZM48.924 18L36 30.924L23.076 18L18 23.076L30.924 36L18 48.924L23.076 54L36 41.076L48.924 54L54 48.924L41.076 36L54 23.076L48.924 18Z" fill="#D30000"/>
</svg>
    <h4 class="mt-3" style="font-size:24px;">Error!</h4>
      <p class="ac-modelpara mb-4">{{name}}</p>
      <button type="button" class="close btn ac-btn-outline-primary ac-butncancel" (click)="closed()">Close</button>

    </div>
  
  `
})

export class NgbdModalContent {
  @Input() name: any;
  @Input() status: any;
  @Input() success: any = "none";
  @Input() error: any = "none";
  @Input() className: any;
  isPayClicked:boolean=false;
  supportLanguages = ['en'];
  constructor(public activeModal: NgbActiveModal) {

  }
  closed() {
    this.activeModal.close();
    parent.location = location.ancestorOrigins.item(0)?.toString()+"/invoices/setting/autopay" || "/invoices";
  }

}


@Component({
  selector: 'app-process-recurring',
  templateUrl: './process-recurring.component.html',
  styleUrls: ['./process-recurring.component.css']
})
export class ProcessRecurringComponent {
  

  token: any;
  paymentMethod: any;
  recurringFalg: boolean = true;
  disabledFlag : boolean = false;
  supportLanguages = ['en'];
  ban:any;
  defaultPaymentMethodId:String='';
  lastDigit:string='';
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private aciPaymentService: AciPaymentService, 
    public translate: TranslateService,
    private invoicesService: InvoicesService,) {


    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.paymentMethod = params['param1'];
      this.lastDigit = params['param2'];
    });

  }

  ngOnInit() {
    var data = JSON.parse(localStorage.getItem("InvoiceList")||"[]");
    this.ban = data.ban;
    this.defaultPaymentMethodId = this.paymentMethod+" - ************"+this.lastDigit;
    //this.getPaymentMethods(this.ban);
  }

  async getPaymentMethods(ban: any) {

    await this.invoicesService.getPaymentMethods(ban).subscribe((res:any) =>{
      res.paymentMethods.forEach((element: any) => {
      
          if ((element.truncatedDda && element.truncatedDda.includes(this.lastDigit)) || (element.cardNumber && element.cardNumber.includes(this.lastDigit))) {
            this.defaultPaymentMethodId = this.paymentMethod + "-" + (this.paymentMethod == 'ACH' ? element.truncatedDda : element.cardNumber);
        }
      });
    });
  }

  openSm(content: any) {
    this.modalService.open(content, { size: 'lg', centered: true,container: 'body'  });
  }
  
  pay() {
    this.disabledFlag=true;
    console.log(this.token)
    console.log(this.recurringFalg)
    this.aciPaymentService.recurring(this.token, this.paymentMethod, this.recurringFalg).subscribe((res: any) => {
      this.open("Success", res.message);
      this.disabledFlag=false;
    }, (err: any) => {
      console.log(err);
      this.open("Error", err);
    });
    ;
  }

  open(status: any, message: any) {
    const modalRef = this.modalService.open(NgbdModalContent);
    if (status == "Success") {
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "block";
      modalRef.componentInstance.error = "none";
    } else {
      //modalRef.componentInstance.name =this.translate.instant("ASM.Invoices.error."+message);
      modalRef.componentInstance.name = message;
      modalRef.componentInstance.success = "none";
      modalRef.componentInstance.error = "block";
    }

  }

  close() {
    this.modalService.dismissAll('Cross click');
    parent.location = location.ancestorOrigins.item(0)?.toString()+"/invoices/setting/autopay" || "/invoices";
  }

}
